const proposalCategories = [
  { id: 1, name: 'Site description / Rationale' },
  { id: 2, name: 'Site manageability' },
  { id: 3, name: 'Delineation' },
  { id: 4, name: 'Consultation' },
  { id: 5, name: 'Species taxonomy' },
  { id: 6, name: 'Ecosystem selection' },
  { id: 7, name: 'Global / Site estimates' },
  { id: 8, name: 'Evidence of presence & RUs' },
  { id: 9, name: 'Assessment parameter' },
  { id: 10, name: 'Criteria met' },
  { id: 11, name: 'Criterion C/E application' },
  { id: 12, name: 'Monitoring assessments' },
  { id: 13, name: 'Feedback addressed' },
  { id: 14, name: 'Other comments' }
]

export default proposalCategories

